import { useEffect, useState } from "react";

/**
 * Track a media query.
 *
 * Layout decisions that change which component renders -- a rail or a drawer -- cannot be made
 * in CSS, so they are made here. Falls back to false where matchMedia is unavailable, which is
 * also what jsdom gives a test that has not stubbed it.
 */
export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? false);

    useEffect(() => {
        const list = window.matchMedia?.(query);
        if (!list) return undefined;

        setMatches(list.matches);
        const onChange = (event) => setMatches(event.matches);

        // Safari below 14 only has the deprecated listener API.
        if (list.addEventListener) {
            list.addEventListener("change", onChange);
            return () => list.removeEventListener("change", onChange);
        }
        list.addListener(onChange);
        return () => list.removeListener(onChange);
    }, [query]);

    return matches;
};

export default useMediaQuery;
